export const getDataFromLocal = (key) => {
  return localStorage.getItem(key);
};

export function setLocalStorage(parentKey, childKey, value) {
  let localData = localStorage.getItem("admin")
    ? JSON.parse(localStorage.getItem("admin"))
    : {};
  localData = {
    ...localData,
    [parentKey]: { ...localData[parentKey], [childKey]: value },
  };
  localStorage.setItem("admin", JSON.stringify(localData));
}

export function getLocalStorage(parentKey, childKey) {
  let localData = JSON.parse(localStorage.getItem("admin")) || {};
  return localData[parentKey]?.[childKey];
}

// Function for create uniqId
export const generateUniqueId = (prefix, length = 10) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let uniqueId = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    uniqueId += characters[randomIndex];
  }
  return `${prefix}_${uniqueId}`;
};
